export class TabSelectEvent extends CustomEvent {
    static name = 'mb-tab-select';

    /** @type {string} */
    selected = undefined;

    /** @type {string} - Human-readable label of the selected tab */
    label = undefined;

    /**
     * @param {string} selected
     * @param {string} [label]
     */
    constructor(selected, label) {
        super(TabSelectEvent.name, { bubbles: true, cancelable: true, composed: true });
        this.selected = selected;
        this.label = label;
    }
}
